import * as Sentry from '@sentry/react';

const REDACT_FIELDS = ['password', 'token', 'otp', 'refreshToken', 'accessToken'];

function redactBody(data) {
  if (!data || typeof data !== 'object') return data;
  const cloned = Array.isArray(data) ? [...data] : { ...data };
  for (const key of Object.keys(cloned)) {
    if (REDACT_FIELDS.includes(key)) {
      cloned[key] = '[Filtered]';
    } else if (cloned[key] && typeof cloned[key] === 'object') {
      cloned[key] = redactBody(cloned[key]);
    }
  }
  return cloned;
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.MODE === 'production',
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_GIT_COMMIT,
  sendDefaultPii: false,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
  ],
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'Non-Error promise rejection captured',
    /extension\//,
    /^chrome-extension:/,
  ],
  beforeSend(event) {
    if (event.request?.data) {
      event.request.data = redactBody(event.request.data);
    }
    if (Array.isArray(event.breadcrumbs)) {
      for (const crumb of event.breadcrumbs) {
        if (crumb?.data && typeof crumb.data === 'object') {
          if (crumb.data.body) crumb.data.body = redactBody(crumb.data.body);
          if (crumb.data.request_body) crumb.data.request_body = redactBody(crumb.data.request_body);
        }
      }
    }
    return event;
  },
});

try {
  const stored = localStorage.getItem('hdl_user');
  if (stored) {
    const u = JSON.parse(stored);
    if (u?._id) {
      Sentry.setUser({ id: u._id, email: u.email, role: u.role });
    }
  }
} catch { /* malformed cache — ignore */ }
